import { render, staticRenderFns } from "./LiveCommentItem.vue?vue&type=template&id=2211f7be&scoped=true&"
import script from "./LiveCommentItem.vue?vue&type=script&lang=js&"
export * from "./LiveCommentItem.vue?vue&type=script&lang=js&"
import style0 from "./LiveCommentItem.vue?vue&type=style&index=0&id=2211f7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2211f7be",
  null
  
)

export default component.exports